@if (this.secondaryBanner() != null) {
  <cgw-banner-promo [dataBanner]="secondaryBanner()"></cgw-banner-promo>
}
